// /az/careers — hub (AZ).
import { createFileRoute } from "@tanstack/react-router";
import { HubPage } from "@/careers/HubPage";
import { careersHead } from "@/careers/head";
import { UI } from "@/careers/spheres";

const ALT = { az: "/az/careers", ru: "/careers", en: "/en/careers" } as const;

export const Route = createFileRoute("/az/careers/")({
  head: () =>
    careersHead({
      lang: "az",
      canonicalPath: "/az/careers",
      altPaths: ALT,
      title: UI.az.metaTitleHub,
      description: UI.az.metaDescHub,
    }),
  component: () => <HubPage lang="az" />,
});
